<p-breadcrumb
  [model]="[{ label: 'Ofertas', routerLink: ['/offers'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Ofertas</h5>
      <p>Gerencie campanhas promocionais</p>
    </div>
    <p-button label="Nova Oferta" routerLink="/offers/create" rounded />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="offers()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>
      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="nameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome"
          class="w-full"
        />
      </div>
      <div class="w-100">
        <p-select
          [options]="productsDropdown()"
          [loading]="productSelectLoading()"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          placeholder="Selecione um produto"
          class="w-full"
          [(ngModel)]="productIdFilter"
          (ngModelChange)="onFilterChange()"
        >
        </p-select>
      </div>
      <div class="w-60">
        <p-select
          [options]="statusFilterOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          class="w-full"
          [(ngModel)]="statusFilter"
          (ngModelChange)="onFilterChange()"
        >
        </p-select>
      </div>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th>Nome</th>
      <th>Produto</th>
      <th>Frequência</th>
      <th>Preço total</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td>{{ item.name || "-" }}</td>
      <td>{{ item.productName }}</td>
      <td>{{ item.paymentFrequencyName }}</td>
      <td>{{ item.fullPrice | currency }}</td>
      <td>
        <div class="w-fit">
          <app-tag-status
            [status]="item.status"
            [text]="getStatusDescription(item.status)"
            class="px-3!"
          />
        </div>
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          [rounded]="true"
          [outlined]="true"
          class="mr-2"
          [routerLink]="'/offers/update/' + item.id"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
